import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function CategorySection() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-baseline gap-3 mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            分类浏览
          </h2>
          <span className="text-accent-500 text-2xl md:text-3xl font-heading">🎯</span>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3 md:gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center gap-3 p-5 md:p-6 rounded-lg bg-background-50 hover:bg-background-100 transition-colors cursor-pointer border border-background-200/70"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-background-100 group-hover:bg-primary-100 transition-colors">
                <i className={`${cat.icon} text-xl md:text-2xl text-primary-500`}></i>
              </div>
              <span className="text-sm font-medium text-foreground-800 group-hover:text-primary-500 transition-colors whitespace-nowrap">
                {cat.name}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}